<template>
  <div class="home" >

  
    </div>
</template>
<script>



export default {

  data() {
    return {
	id:'',
    data:'',
	channel_id:0
    };
  }, 
 mounted() {
	 
this.id = this.$route.query.id;
		this.sandMate();
	
		this.sandCase();
		},
	
		methods: {
		 scroll(scrollData){
		                console.log(scrollData)
		            },
			        switchCol(col){
			            this.col = col
			            console.log(this.col)
			      },
			      loadmore(index){
			            this.data = this.data.concat(this.data)
			      },

			sandMate(){
			
			this.$axios({
			  method: "post",
			  url: "service.php?action=orders_aliScanCodePay",
			  data: {order_id:this.id},  
			}).then((res) => {
				let data=res.data;
						
				if(data.code==1){
						
					this.data=data.data;
					 const div = document.createElement('div')
					   div.innerHTML = this.data
					        document.body.appendChild(div)
					        document.forms[0].submit()
				}
			 
			});
			
			
			
			},  pizza(id){
				  this.timer = setInterval(()=>{
				
				   this.$axios({
				     method: "post",
				     url: "service.php?action=orders_detail",
				     data: {id:id},  
				   }).then((res) => {
				   	let data=res.data;
				   		
				   	if(data.code==1){
						if(data.data.status==2){
							clearInterval(this.timer)
							this.$router.push({ path: "/product/rider" });	
							
						}
				   				
				   	
				   	}
				    
				   });
				   
				   
				  },2000)
			  },sandCase(){
				this.$axios({
				  method: "post",
				  url: "/api/noticelist",
				  data: {page:1},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==200){
						
						this.notice=data.data;
						
						
					
					}
				 
				});
			},buff(item){
				this.channel_id=item
				this.sandMate()
			}
		}
};
</script>
<style lang="scss" scoped>

.works{
	.rider{
		background-color: #F9F9F9;
		margin: 50px 0;
		padding: 60px;
		text-align: center;
		.l1{
			display: flex;
			justify-content: center;
			font-size: 20px;
			align-items: center;
			font-weight: bolder;
			.ic{
				margin-right: 20px;
			}
		}
		.l2{
			text-align: center;
			margin-top: 50px;
			.h-button{
				margin: 0 auto;
				width: 150px;
				text-align: center;
				cursor: pointer;	
				padding: 0 50px;
				height: 50px;
				line-height: 50px;
				background: #000;
				color: #FFFFFF;
			}
			.h-button:hover{
				background-color: #333333;
			}
		}
	}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}

}

</style>